/**
 * 
 */

import addTask from './dragdrop';
//const {addTask} = initializePackery();
import { useState } from 'react';
import {getSprintHistory} from './sprintHistory';

import { yData ,deleteTask,restoreSprint,editTask,updateMemberName} from './hooks/sprintboard';
import { createRoot } from 'react-dom/client';
import { HistoryHandler } from './sprintHistory';
//let taskCount = 0;
let setYData;

//idがmodalのエレメントをディスプレイで表示
function handleButtonClick() {
    const modal = document.getElementById("modal");
    const modalOverlay = document.getElementById("modal-overlay");
    const dicisionButton = document.getElementById("dicisionButton");
    const delButton = document.getElementById("deleteButton");

    modal.style.display = "block";
    modalOverlay.style.display = "block";
    dicisionButton.style.display = "block";
    delButton.style.display = "none";

    
    resetModalFields();
    //const taskColor = document.getElementById("taskColor");
    //taskColor.value = "#ffffff";
    
    //document.getElementById("taskColor").value = "white";
  }

  function resetModalFields(){
    document.getElementById("taskTitle").value = "";
    document.getElementById("creatorTextArea").value = "";
    document.getElementById("difficultyTextArea").value = "";
    document.getElementById("contentTextArea").value = "";
    document.getElementById("memoTextArea").value = "";
    document.getElementById("taskColor").value = "#ffffff";

  }

  function memverEdit(){
     
  }

  //idがmodalのエレメントをディスプレイで非表示
  function handleCloseClick() {
    const modal = document.getElementById("modal");
    const modalOverlay = document.getElementById("modal-overlay");

    const dicisionButton = document.getElementById("dicisionButton");
    const delButton = document.getElementById("deleteButton");

    dicisionButton.style.display = "none";
    delButton.style.display = "none";

    modal.style.display = "none";
    modalOverlay.style.display = "none";

    modal.dataset.key = "";
    modal.dataset.grid = "";

    document.getElementById("taskTitle").value = "";
    document.getElementById("creatorTextArea").value = "";
    //難易度をdifficultyとして書いていたが「重み」にしたい
    document.getElementById("difficultyTextArea").value = "";
    document.getElementById("contentTextArea").value = "";
    document.getElementById("memoTextArea").value = "";


  }
  
  //メモボタンの表示・非表示
  function handleMemoClick() {
    const memoTextArea = document.getElementById("memoTextArea");
    if (memoTextArea.style.display === "none") {
      memoTextArea.style.display = "block";
    } else {
      memoTextArea.style.display = "none";
    }
  }
  
  function changeClick(){
    const modal = document.getElementById("modal");
    
    const gridName = modal.dataset.grid;
    const key = modal.dataset.key;
    deleteTask(gridName,key);
  }


  //決定ボタンを押したら
  //modalのkeyなどでタスクの作成とタスクの編集を切り替える
  //タスクが編集されたか判断はしてない(何も変えずに決定だけ押してもログが残る)
  function handleDicisionClick() {

  
    const modal = document.getElementById("modal");
    const modalOverlay = document.getElementById("modal-overlay");
    modal.style.display = "none";
    modalOverlay.style.display = "none";

    const gridName = modal.dataset.grid;
    const key = modal.dataset.key;

    if(modal.dataset.key != ""){
      const taskTitle = document.getElementById("taskTitle").value;
      const creatorName = document.getElementById("creatorTextArea").value;
      //難易度をdifficultyとして書いていたが「重み」にしたい
      const difficulty = document.getElementById("difficultyTextArea").value;
      const content = document.getElementById("contentTextArea").value;
      const memo = document.getElementById("memoTextArea").value;

      const taskColor = document.getElementById("taskColor").value;

      editTask(gridName,key,taskTitle,creatorName,difficulty,content,memo,taskColor);
    }
    else{
      let taskCount = yData.get("taskCount");

    //ydataに紐づけ]
    setYData({
      [taskCount]:{
        teamid:"",
        taskTitle:document.getElementById("taskTitle").value,
        creator:document.getElementById("creatorTextArea").value,
        difficulty:document.getElementById("difficultyTextArea").value,
        time:"",//タスク変更の時間
        content:document.getElementById("contentTextArea").value,
        memo:document.getElementById("memoTextArea").value,
        elemLeft:"0",
        elemTop:"0",
        width:"40",
        height:"40",
        taskColor:document.getElementById("taskColor").value
      }
    });
    }

    modal.dataset.key = "";
    modal.dataset.grid = "";

  }

  //タスクの表示(modalをblockにする)
  function openTask(key,value,mapName,state){

    const modal = document.getElementById("modal");
    const modalOverlay = document.getElementById("modal-overlay");
    const dicisionButton = document.getElementById("dicisionButton");
    const delButton = document.getElementById("deleteButton");
    modal.style.display = "block";
    modalOverlay.style.display = "block";
    
    //普通のときだけ決定ボタンと削除ボタンを表示
    if(state == "1"){
      dicisionButton.style.display = "block";
      delButton.style.display = "block";
    }
    else{
      dicisionButton.style.display = "none";
      delButton.style.display = "none";
    }

    document.getElementById("taskTitle").value = value.taskTitle;
    document.getElementById("creatorTextArea").value = value.creator;
    document.getElementById("difficultyTextArea").value = value.difficulty;
    document.getElementById("contentTextArea").value = value.content!== undefined ? value.content : "";
    document.getElementById("memoTextArea").value = value.memo;

    document.getElementById("taskColor").value = value.taskColor;

    modal.dataset.grid = mapName;
    modal.dataset.key = key;
  }



  function handleDeleteButton(){
    const modal = document.getElementById("modal");
    const modalOverlay = document.getElementById("modal-overlay");
    modal.style.display = "none";
    modalOverlay.style.display = "none";
    const gridName = modal.dataset.grid;
    const key = modal.dataset.key;

    modal.dataset.key = "";
    modal.dataset.grid = "";
    deleteTask(gridName,key);
  }

  let root = null;
  function historyDisplay(teamNumber){
    getSprintHistory(teamNumber).then(updatesList => {
      const hModalOverlay = document.getElementById("history-modal-overlay");
      const historyModal = document.getElementById("historyModal");
      hModalOverlay.style.display = "block";
      historyModal.style.display = "block";
      

      if(!root){
        root = createRoot(historyModal);
      }      
      root.render(<HistoryHandler updatesList={updatesList} teamNumber={teamNumber}/>);

    });
  }

  function historyClose(){
    const hModalOverlay = document.getElementById("history-modal-overlay");
      const historyModal = document.getElementById("historyModal");
      hModalOverlay.style.display = "none";
      historyModal.style.display = "none";
  }


  function restoreSelectionHistory(selectYData,tempTeamNum){
    const teamNumber = location.state ? location.state.teamNumber : null;

    
    restoreSprint(selectYData,tempTeamNum);
    historyClose();
  }

  export function useSetYData(callback) {
    setYData = callback;
  }
  
  function submitForm() {
    location.href = "./TaskServlet?aaa=" + document.getElementById("taskTitle").value;
  }


  //チームメンバーの名前の編集:編集画面の開閉，決定，閉じる
  function openNameDicision(){
    const editNameModal = document.getElementById("editNameModal");
    const modalOverlay = document.getElementById("modal-overlay");
    editNameModal.style.display = "block";
    modalOverlay.style.display = "block";

    
    const name0 = document.getElementById("name0");
    const name1 = document.getElementById("name1");
    const name2 = document.getElementById("name2");
    const name3 = document.getElementById("name3");
    const name4 = document.getElementById("name4");

    name0.value = yData.get("MemberName").get("0") !== undefined ? yData.get("MemberName").get("0") : "";
    name1.value = yData.get("MemberName").get("1") !== undefined ? yData.get("MemberName").get("1") : "";
    name2.value = yData.get("MemberName").get("2") !== undefined ? yData.get("MemberName").get("2") : "";
    name3.value = yData.get("MemberName").get("3") !== undefined ? yData.get("MemberName").get("3") : "";
    name4.value = yData.get("MemberName").get("4") !== undefined ? yData.get("MemberName").get("4") : "";
    
  }

  function closeNameDicision(){
    const editNameModal = document.getElementById("editNameModal");
    const modalOverlay = document.getElementById("modal-overlay");
    editNameModal.style.display = "none";
    modalOverlay.style.display = "none";
  }
  
  function editNameDicision(){
    const editNameModal = document.getElementById("editNameModal");
    const modalOverlay = document.getElementById("modal-overlay");
    editNameModal.style.display = "none";
    modalOverlay.style.display = "none";

    updateMemberName();
  }



  export {  handleButtonClick, handleCloseClick, handleMemoClick, handleDicisionClick, 
            submitForm ,openTask,historyDisplay,historyClose,restoreSelectionHistory,handleDeleteButton,openNameDicision,closeNameDicision,editNameDicision};


